import gql from "graphql-tag";

export default gql`
  query FreeFloatHistory($tickerSymbol: TickerSymbol!) {
    freeFloatHistory(tickerSymbol: $tickerSymbol) {
      asOfDate
      totalSharesOutstanding
      floatShare
      floatShareToTotalSharesOutstanding
    }
  }
`;
